<!--
    说明：主要包含封面图，头部。
    创建时间：2022/6/27
    创建者：congpeizhi
-->
<template>
    <div class="detail-cover">
        <!-- 视频封面图 -->
        <div class="detail-cover-image">
            <img :src="course.coverImg" v-toWebp />
        </div>
        <!-- 讲解回放or播放宣传片or不展示，优先级为 宣传片 > 回放讲解 > 封面图 -->
        <div
            v-if="!isHarmony && (course.coverPhotoPlayUrl || livePlayUrl)"
            class="detail-cover-btn"
            @click="playUrlBtn"
        >
            <img src="../img/play.png" class="detail-cover-btn_play" />
            <span>{{ coverBtnWriter }}</span>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, PropType, computed } from 'vue';
import { getLiveExplainReplay, CourseDetailCourse } from '../service';
import { Goto } from '@/utils/url';
import { isHarmony } from '@/utils/utils';
export default defineComponent({
    props: {
        course: {
            type: Object as PropType<CourseDetailCourse>,
            default: () => {
                return {};
            },
        },
        distributionId: {
            type: String,
            default: null,
        },
    },
    setup(props) {
        // 封面图btn文案，根据宣传片 > 回放讲解 > 封面图优先级展示文案
        const coverBtnWriter = computed(() => {
            return props.course.coverPhotoId ? '播放宣传片' : '讲解回放';
        });
        // 获取url中的课程id
        const courseId = location.pathname.match(/\d+/g).join('');
        // 回放讲解的播放链接
        const livePlayUrl = ref('');
        // 播放点击触发，跳到播放页
        const playUrlBtn = (): void => {
            const str = props.course.coverPhotoId
                ? `kwai://work/${props.course.coverPhotoId}`
                : livePlayUrl.value;
            Goto(str);
        };
        // 回放讲解，直播课会有回放讲解，只有封面头部这里会用到这个接口
        getLiveExplainReplay({
            courseId: courseId,
            courseDistributionId: props.distributionId,
        }).then(({ data }): void => {
            livePlayUrl.value = data ? data.photoUrl : '';
        });
        return {
            coverBtnWriter,
            livePlayUrl,
            playUrlBtn,
            isHarmony,
        };
    },
});
</script>

<style lang="less" scoped>
.detail-cover {
    width: 100vw;
    height: 260px;
    overflow: hidden;
    position: relative;
    .detail-cover-image {
        height: 100%;
        img {
            width: 100%;
            object-fit: cover;
        }
    }
    .detail-cover-btn {
        width: 144px;
        height: 44px;
        background: rgba(0, 0, 0, 0.4);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 40px;
        display: flex;
        justify-content: center;
        flex-flow: row nowrap;
        align-items: center;
        &_play {
            width: 22px;
            margin-right: 5px;
        }
        span {
            font-family: 'PingFang SC';
            font-weight: 500;
            font-size: 17px;
            color: #fff;
        }
    }
}
</style>
